import { render, staticRenderFns } from "./StepConnectPages.vue?vue&type=template&id=28fc0582&scoped=true"
import script from "./StepConnectPages.vue?vue&type=script&lang=js"
export * from "./StepConnectPages.vue?vue&type=script&lang=js"
import style0 from "./StepConnectPages.vue?vue&type=style&index=0&id=28fc0582&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fc0582",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28fc0582')) {
      api.createRecord('28fc0582', component.options)
    } else {
      api.reload('28fc0582', component.options)
    }
    module.hot.accept("./StepConnectPages.vue?vue&type=template&id=28fc0582&scoped=true", function () {
      api.rerender('28fc0582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/onboarding/steps/StepConnectPages.vue"
export default component.exports